export const ExportIcon = () => (
  <svg viewBox='0 0 34 34' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M5.66675 17V28.3333C5.66675 29.0848 5.96526 29.8054 6.49661 30.3368C7.02797 30.8682 7.74863 31.1667 8.50008 31.1667H25.5001C26.2515 31.1667 26.9722 30.8682 27.5036 30.3368C28.0349 29.8054 28.3334 29.0848 28.3334 28.3333V17'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M22.6666 8.49992L16.9999 2.83325L11.3333 8.49992'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M17 2.83325V21.2499'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
